<div class="video-modal">
  <button class="video-modal__close" (click)="close()" aria-label="Close video">
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <path d="M15 5L5 15M5 5l10 10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    </svg>
  </button>

  <div class="video-modal__player">
    <video
      #videoEl
      class="video-modal__video"
      [src]="videoSrc"
      autoplay
      controls
      playsinline
      preload="none"
    ></video>
  </div>
</div>
